import { colors } from 'resources/tokens';
import { stylesheet } from 'typestyle';

const actionRow = {
  display: 'flex',
  justifyContent: 'space-between',
  label: {
    marginBottom: '0',
    span: {
      '*[role=img]': {
        height: '1rem',
        width: '1rem',
      },
    },
  },
  marginTop: '.25rem',
  width: '100%',
};
export const campaignSummaryCSS = stylesheet({
  actions: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  expandButtons: {
    $nest: {
      '.btn': {
        color: colors.primary,
        padding: 0,
        verticalAlign: 'top',
      },
    },
    margin: '1rem 0',
  },
  selectAllCheckBoxLabel: {
    fontSize: '0.875rem',
  },
});

export const campaignSummaryTableCSS = stylesheet({
  headerRow: {
    fontSize: '1rem',
  },
});

export const campaignSummaryRowCSS = stylesheet({
  headerContainer: {
    display: 'flex',
    gap: '0.5rem',
    justifyContent: 'space-between',
  },
  headerSubcontainer: {
    alignItems: 'center',
    display: 'flex',
    gap: '.5rem',
  },
  horizontalRule: {
    marginBottom: 0,
  },
  placementContainer: {
    padding: 10,
  },
});

export const subTableCSS = stylesheet({
  actionButton: {
    $nest: {
      '.btn': {
        color: colors.primary,
        padding: 0,
        verticalAlign: 'top',
      },
    },
    color: colors.primary,
  },
  actionButtons: {
    alignItems: 'baseline',
    display: 'flex',
    gap: '.75rem',
    justifyContent: 'space-between',
  },
  actionLink: {
    $nest: {
      '.btn': {
        color: colors.primary,
        padding: 0,
        verticalAlign: 'top',
      },
    },
    color: colors.primary,
  },
  actionRow,
  cellLabel: {
    fontWeight: 700,
  },
  contentAnchorLink: {
    flexGrow: 1,
    marginLeft: '.1rem',
  },
  contentCheckboxLabel: {
    fontSize: '0.875rem',
    marginBottom: 0,
  },
  headerRow: {
    backgroundColor: '#F0F1F2',
    fontWeight: 700,
    padding: '0 .5rem',
    textTransform: 'uppercase',
    width: '100%',
  },
  placementActionRow: {
    $nest: {
      label: {
        $nest: {
          span: {
            $nest: {
              '*[role=img]': {
                height: '1rem',
                width: '1rem',
              },
            },
          },
        },
        marginBottom: '0',
      },
    },
    justifyContent: 'space-between',
    marginTop: '.5rem',
  },
  placementActionSubcontainer: {
    display: 'flex',
    gap: '1rem',
  },
  placementAnchorLink: {
    flexGrow: 1,
    fontSize: '0.875rem',
  },
  previewInSymphonyContainer: {
    alignItems: 'center',
    display: 'flex',
    gap: '0.25rem',
  },
  rowDivider: {
    margin: '.5rem 0 0',
  },
  secondaryActionRow: {
    ...actionRow,
    paddingLeft: '1.5rem',
  },
  subTable: {
    $nest: {
      tbody: {
        $nest: {
          tr: {
            $nest: {
              td: {
                backgroundColor: 'unset',
                padding: '.25rem 0',
              },
            },
          },
        },
      },
      'tbody > tr:last-child > *': {
        backgroundColor: 'unset',
        borderWidth: '0',
      },
      thead: {
        lineHeight: '.5rem',
      },
      'thead > tr:last-child > *': {
        backgroundColor: 'unset',
        borderWidth: '0',
      },
    },
    fontSize: '0.875rem',
    overflowWrap: 'anywhere',
    paddingLeft: '1rem',
    wordBreak: 'normal',
  },
  subTableContainer: {
    margin: '1rem 0 1rem 2rem',
  },
  subTableSpacer: {
    marginLeft: '1rem',
  },
});

export const summaryTableErrorListCSS = stylesheet({
  errorContainer: {
    margin: '0.5rem 0',
  },
});

export const summaryTableErrorItemCSS = stylesheet({
  title: {
    fontWeight: 'bold',
  },
});

export const summaryTableBullseyeCSS = stylesheet({
  link: {
    $nest: {
      '&:hover': {},
    },
    margin: '.2rem',
    padding: '.2rem',
  },
});

export const placementSummaryRowCSS = stylesheet({
  dataRowWrapper: {
    alignItems: 'center',
    color: colors.linkText,
    display: 'inline-flex',
    gap: '0.4rem',
  },
  description: {
    minWidth: '8rem',
    wordBreak: 'break-word',
  },
  removeButtonIcon: {
    alignItems: 'left',
    display: 'inline',
  },
  renderDataStyle: {
    alignItems: 'center',
    display: 'inline-flex',
    gap: '0.1rem',
  },
  renderNoDataStyle: {
    gridColumn: '2 / 5',
  },
});
